import React from 'react'

interface ProgressBarProps {
  current: number
  total: number
  onBack?: () => void
  canGoBack?: boolean
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ current, total, onBack, canGoBack = false }) => {
  const percentage = (current / total) * 100

  return (
    <div className="progress-container">
      <div className="progress-header">
        <button
          className="back-button"
          onClick={onBack}
          disabled={!canGoBack}
          style={{ visibility: canGoBack ? 'visible' : 'hidden' }}
          title="Go to previous slide"
        >
          ←
        </button>
        <div
          className="progress-bar"
          style={{ cursor: 'default' }}
          title="Quiz progress"
        >
          <div className="progress-fill" style={{ width: `${percentage}%` }} />
        </div>
      </div>
    </div>
  )
}
